import {
  DialogActions,
  DialogContent,
  DialogTitle,
  Link,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { EGBasicSelect } from "../../../../../../MainComponents/Select/EGBasicSelect";
import { useReportContext } from "../../../../../ReportContext/useReportContext";
import { useTranslation } from "react-i18next";
import { EGInput } from "../../../../../../MainComponents/Input/EGInput";
import { EGButton } from "../../../../../../MainComponents/Button/EGButton/EGButton";
import { EGIconButton } from "../../../../../../MainComponents/Button/IconButton/IconButton";
import { useParams } from "react-router";
import { useSnackbar } from "notistack";
import { updateMeasure } from "../../../../../../../apis";

export const EditMeasuresForm = ({
  content,
  hdlCloseDialog,
  getAllMeasures,
  reportRender,
}) => {
  // Custom Hooks
  const { measureOptions } = useReportContext();
  const [t] = useTranslation("report");
  const { id } = useParams();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  // Initial States
  const [measure, setMeasure] = useState(content.measure);
  const [another_measure, setAnother_measure] = useState(
    content.another_measure || ""
  );
  const [comment, setComment] = useState(content.comment || "");
  const [addDetails, setAddDetails] = useState(comment !== "" || false);
  const [isLoading, setIsLoading] = useState(false);

  // Validation info
  const isInvalid =
    !measure ||
    (measure === "another" &&
      (another_measure.trim() === "" || another_measure.length < 3));
  // Sending form
  const onSubmitMesure = async (e) => {
    e.preventDefault();
    const measureDataUpdate = {
      report_identifier: Number(id),
      id: content.id,
      measure,
      comment,
    };
    // Only add another_measure if it has a value
    if (measure === "another" && another_measure) {
      measureDataUpdate.another_measure = another_measure;
    }
    setIsLoading(true);

    const sending = enqueueSnackbar(`${t("Resolution.sending")}...`, {
      variant: "info",
      persist: true,
    });

    try {
      await updateMeasure(measureDataUpdate).then((resp) => {
        if (resp.status === 201) {
          setIsLoading(false);
          hdlCloseDialog();
          getAllMeasures();
          reportRender();
          closeSnackbar(sending);
          enqueueSnackbar(t("Resolution.measure_added_successfully"), {
            variant: "success",
          });
        }
      });
    } catch (error) {
      console.error(error);
      setIsLoading(false);
      closeSnackbar(sending);
    }
  };

  return (
    <>
      <EGIconButton
        iconName="cancel_circle"
        iconColor="primary"
        onClick={hdlCloseDialog}
        sx={{ position: "absolute", top: 15, right: 12 }}
        iconSize={25}
      />
      <DialogTitle align="center" component="h3" color="secondary">
        {t("Resolution.corrective_preventive_measure")}
      </DialogTitle>
      <DialogContent>
        <EGBasicSelect
          options={measureOptions}
          value={measure}
          onChange={(e) => setMeasure(e.target.value)}
          label={`${t("Resolution.select_corrective_preventive_measure")}:`}
          sx={{ mt: 1 }}
        />
        {measure === "another" && (
          <EGInput
            label={`${t("Resolution.new_corrective_preventive_measure")}:`}
            placeholder={t("Resolution.example_implement_monthly_audits")}
            sx={{ mt: 1.75 }}
            value={another_measure}
            onChange={(e) => setAnother_measure(e.target.value)}
            isValid={
              another_measure.length > 2 && another_measure.trim() !== ""
            }
            helperText={t("Resolution.enter_new_corrective_preventive_measure")}
          />
        )}
        {!addDetails && (
          <Typography textAlign="end" my={0.33}>
            <Link
              underline="hover"
              onClick={() => {
                setAddDetails(true);
                setTimeout(() => {
                  window.scrollTo({
                    top: document.documentElement.scrollHeight,
                    behavior: "smooth",
                  });
                }, 100);
              }}
            >
              {`+ ${t("Resolution.add_comment")}`}
            </Link>
          </Typography>
        )}

        {addDetails && (
          <EGInput
            sx={{ mt: 1.75, mb: 0.75 }}
            label={`${t("Resolution.details")}: ${comment.length}/500`}
            placeholder={t("Resolution.enter_details_related_selected_measure")}
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            multiline
            inputProps={{ maxLength: 500 }}
            rows={3.5}
            autoFocus
          />
        )}
      </DialogContent>
      <DialogActions>
        <EGButton
          label={t("Resolution.save")}
          onClick={onSubmitMesure}
          loading={isLoading}
          iconName={isInvalid ? "mark_check" : "mark_check_bold"}
          disabled={isInvalid}
          color={isInvalid ? "light" : "success"}
          iconColor={isInvalid ? "" : "white"}
          iconColorHover={isInvalid ? "" : "white"}
          labelColor={isInvalid ? "" : "white"}
        />
        <EGButton
          iconName="close_icon"
          iconSize={21}
          label={t("Resolution.cancel")}
          onClick={hdlCloseDialog}
          loading={isLoading}
        />
      </DialogActions>
    </>
  );
};
